import { Grid } from '@material-ui/core'
import React from 'react'
import CheckBoxWithLabel from '../../CheckBoxWithLabel'
import CustomHeading from '../../CustomHeading'
import CustomAddForm from './CustomAddForm'

function PositionFormComp({ state, setState, modules, setModules }) {
  const { name, rank, positionCode, control} = state

  //console.log('MODULES : ', modules)

  const rankOptions = [
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
    { value: 6, label: '6' },
    { value: 7, label: '7' },
    { value: 8, label: '8' },
    { value: 9, label: '9' },
    { value: 10, label: '10' },

  ]
  const controlOptions = [
    { value: 1, label: 'Regional' },
    { value: 2, label: 'Zonal' },
    { value: 3, label: 'State' },
    { value: 4, label: 'City' },
    { value: 5, label: 'District' },
    { value: 6, label: 'Area' },
  ]
  const data = [
    { label: 'Position Code', value: positionCode, name: 'positionCode' },
    { label: 'Name', value: name, name: 'name' },
    { label: 'Rank', value: rank, name: 'rank', options: rankOptions, fieldName: 'label', fieldValue: 'value' },
    { type: 'MULTI', label: 'Control', value: control, name: 'control', options: controlOptions, fieldName: 'label', fieldValue: 'label', multiple: true },

  ]

  return (
    <>
      <CustomAddForm data={data} state={state} setState={setState} />
      <Grid item lg={12}>
        {/* {Object.keys(modules).map((item) => {
          //console.log('ITEM : ', item)
          return (
            <>
              <CheckBoxWithLabel value={item.FLAG} form={modules} setForm={setModules} label={item} name={'FLAG'} />
              <br />

              {Object.keys(modules[item]).map((val) => (
                <>{val != 'FLAG' && <CheckBoxWithLabel value={item[val]} form={modules} setForm={setModules} label={item} name={val} />}</>
              ))}
              <br />
            </>
          )
        })} */}
      </Grid>
    </>

    //  <Grid container>
    //</Grid> {data.map((item, index) =>
    //     item.select ? (
    //       <Grid item lg={4}>
    //         <CustomSelect
    //           label={item.label}
    //           button={item.button}
    //           options={item.options}
    //           value={item.value}
    //           // handleChange={item.handleChange}
    //           form={state}
    //           setForm={setState}
    //           formCheck={true}
    //           name={item.name}
    //           disabled={item.disabled}
    //         />
    //       </Grid>
    //     ) : (
    //       <Grid item lg={4}>
    //         <CustomInput
    //           label={item.label}
    //           icon={item.icon}
    //           name={item.name}
    //           value={item.value}
    //           number={item.number ? true : false}
    //           form={state}
    //           setForm={setState}
    //           formCheck={true}
    //           type={item.type}
    //         />
    //       </Grid>
    //     )
    //   )}

    //  <Grid item lg={12}>
    //   <CustomHeading heading="Modules" />
    //   {Object.keys(modules).map((item) => {
    //     //console.log('ITEM')
    //     return (
    //       <>
    //         <CheckBoxWithLabel value={item.FLAG} form={modules} setForm={setModules} label={item} name={'FLAG'} />
    //         <br />

    //         {Object.keys(modules[item]).map((val) => (
    //           <>
    //             {val != 'FLAG' && (
    //               <CheckBoxWithLabel value={item[val]} form={modules} setForm={setModules} label={item} name={val} />
    //             )}
    //           </>
    //         ))}
    //         <br />
    //       </>
    //     )
    //   })}
    // </Grid>
    // </Grid>
  )
}

export default PositionFormComp